import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const Chatbot = () => {
  const [messages, setMessages] = useState([
    { text: "Hello! Welcome to our interior design studio. How can we assist you today?", sender: 'bot' }
  ]);
  const [userNumber, setUserNumber] = useState('');
  const [showNumberInput, setShowNumberInput] = useState(false);
  const [isInitialOptions, setIsInitialOptions] = useState(true);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [chatbotState, setChatbotState] = useState({ mobile: '' });

  const options = [
    'Request a Consultation',
    'View Portfolio',
    'Get Pricing Details'
  ];

  const handleOptionClick = (option) => {
    const newMessages = [...messages, { text: option, sender: 'user' }];
    setMessages(newMessages);
    setIsInitialOptions(false);
    
    setTimeout(() => {
      if (option === 'Request a Consultation') {
        setMessages(prev => [
          ...prev,
          { text: "Great! Please share your phone number so we can schedule a call.", sender: 'bot' }
        ]);
        setShowNumberInput(true);
      } else if (option === 'View Portfolio') {
        setMessages(prev => [
          ...prev,
          { 
            text: (
              <a 
                href="/portfolio" 
                className="text-blue-600 underline hover:text-blue-800" 
              >
                View our portfolio here
              </a>
            ), 
            sender: 'bot' 
          }
        ]);
      } else if (option === 'Get Pricing Details') {
        setMessages(prev => [
          ...prev,
          { text: "Our pricing varies based on project scope. Please specify your requirements or share your phone number for a detailed quote.", sender: 'bot' }
        ]);
        setShowNumberInput(true);
      }
    }, 600);
  };

  const sendChatMessageEmail = (number) => {
    const templateParams = {
      message: "User's mobile number is: " + number,
      time: new Date().toLocaleString()
    };

    emailjs.send("service_j3icm5h", "template_7hp3ivy", templateParams, "LsrTno83fC_TipZ0n")
      .then(function(response) {
        console.log("✅ Email sent successfully!", response.status, response.text);
        // alert("Thank you! Your number has been submitted.");
      }, function(error) {
        console.error("❌ Failed to send email:", error);
        // alert("Error sending your number. Please try again.");
      });
  };

  const handleSubmitNumber = () => {
    if (userNumber.trim()) {
      const newMessages = [...messages, { text: userNumber, sender: 'user' }];
      setMessages(newMessages);
      setChatbotState(prev => ({ ...prev, mobile: userNumber }));
      
      setTimeout(() => {
        setMessages(prev => [
          ...prev,
          { text: `Thanks! We'll contact you at ${userNumber} shortly.`, sender: 'bot' }
        ]);
        setShowNumberInput(false);
        setUserNumber('');
        sendChatMessageEmail(userNumber);
      }, 600);
    }
  };

  const handleToggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  const getMessagesHeight = () => {
    if (isInitialOptions) {
      return 'calc(100% - 281px)';
    }
    return 'calc(100% - 143px)';
  };

  return (
    <>
      {!isChatOpen && (
        <button
          onClick={handleToggleChat}
          className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 w-14 h-14 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-200"
          style={{ backgroundColor: '#02331F', color: '#A47336' }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z" clipRule="evenodd" />
          </svg>
        </button>
      )}

      {isChatOpen && (
        <div 
          className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 bg-white rounded-lg shadow-xl border border-gray-100 overflow-hidden"
          style={{ 
            width: '360px', 
            height: '520px',
            maxWidth: 'calc(100vw - 32px)',
            maxHeight: 'calc(100vh - 32px)'
          }}
        >
          <div className="text-white p-4 border-b border-gray-100" style={{ backgroundColor: '#02331F' }}>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center" style={{ color: '#02331F' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"/>
                  </svg>
                </div>
                <div>
                  <h3 className="font-medium text-sm">Interior Design Studio</h3>
                  <p className="text-xs opacity-75">We're here to help</p>
                </div>
              </div>
              <button
                onClick={handleToggleChat}
                className="text-white hover:text-gray-200 transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>

          <div 
            className="flex-1 p-4 overflow-y-auto bg-gray-50" 
            style={{ height: getMessagesHeight() }}
          >
            <div className="space-y-4">
              {messages.map((msg, index) => (
                <div 
                  key={index} 
                  className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`}
                >
                  <div 
                    className={`max-w-xs rounded-lg px-3 py-2 text-sm ${msg.sender === 'user' 
                      ? 'bg-white text-gray-800 border border-gray-200' 
                      : 'bg-white text-gray-700 border border-gray-100 shadow-sm'}`}
                  >
                    {React.isValidElement(msg.text) ? msg.text : msg.text}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="border-t border-gray-100 p-4 bg-white">
            {showNumberInput ? (
              <div className="flex space-x-2">
                <input
                  type="text"
                  value={userNumber}
                  onChange={(e) => setUserNumber(e.target.value)}
                  placeholder="Enter your phone number"
                  className="flex-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:border-gray-300"
                  style={{ '--tw-ring-color': '#02331F' }}
                />
                <button
                  onClick={handleSubmitNumber}
                  className="text-white px-4 py-2 rounded-lg hover:opacity-90 transition-opacity"
                  style={{ backgroundColor: '#02331F' }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
                    <path fillRule="evenodd" d="M3 10a1 1 0 011-1h10a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
            ) : isInitialOptions ? (
              <div className="space-y-3">
                <p className="text-xs text-gray-500 font-medium">How can we help you?</p>
                <div className="space-y-2">
                  {options.map((opt, index) => (
                    <button
                      key={index}
                      onClick={() => handleOptionClick(opt)}
                      className="w-full text-left bg-white hover:bg-gray-50 border border-gray-200 py-3 px-4 rounded-lg text-sm text-gray-700 transition-colors"
                    >
                      {opt}
                    </button>
                  ))}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
};

export default Chatbot;